// import jwtDecode from 'jwt-decode';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  // ----------------------------------------------------------------------

  // const decoded = jwtDecode(accessToken);
  // const currentTime = Date.now() / 1000;

  // return decoded.exp > currentTime;
  return true;
};

const isValidUser = (user) => {
  if (!user || typeof user !== 'object' || Array.isArray(user)) {
    return false;
  }
  if (Object.keys(user).length === 0) {
    return false;
  }
  const hasIdentifier = Boolean(user.id || user.email || user.username || user.client_id || user._id);
  const hasTypeOrRole = Boolean(user.userType || user.role || user.userRole);
  return Boolean(hasIdentifier || hasTypeOrRole);
};

const setSession = (accessToken, user) => {
  if (accessToken && isValidUser(user)) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('arsh:user', JSON.stringify(user));
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('arsh:user');
    delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, isValidUser, setSession };

